import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';
import { isDev } from './config.js';
import Header from './organisms/Header.js';
import Single from './organisms/Single.js';
import Konami from './atoms/Konami.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./molecules/Video.js').default>>
 *     Accordion: Array<Promise<import('./molecules/Accordion.js').default>>
 *     Slider: Array<Promise<import('./molecules/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @extends {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Figure,
      Header,
      Single,
      Konami,
      ImagesHover: (app) =>
        importWhenVisible(() => import('./molecules/ImagesHover.js'), 'ImagesHover', app),
      ImageZoom: (app) =>
        importWhenVisible(() => import('./molecules/ImageZoom.js'), 'ImageZoom', app),
      Slider: (app) => importWhenVisible(() => import('./molecules/Slider.js'), 'Slider', app),
      Video: (app) => importWhenVisible(() => import('./molecules/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion.js'), 'Accordion', app),
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.$log('mounted 🎉');
  }
}

export default createApp(App, document.body);
